import React from 'react';

import JwtAuthProvider from '@auth/services/jwt/JwtAuthProvider';
import { FuseAuthProviderType } from '@fuse/core/FuseAuthProvider/types/FuseAuthTypes';
import FuseAuthProvider from '@fuse/core/FuseAuthProvider';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import { mustChangePasswordFromToken } from '@auth/services/jwt/utils/jwtUtils';
import { useLocation, useNavigate } from 'react-router';
import { User } from '@auth/user';
import FuseLoading from '@fuse/core/FuseLoading';

/**
 * The Authentication providers - Only JWT for Dorat
 */
const authProviders: FuseAuthProviderType[] = [
	{
		name: 'jwt',
		Provider: JwtAuthProvider
	}
];

type AuthenticationProps = {
	children: React.ReactNode;
};

function RedirectToChangePassword() {
	const navigate = useNavigate();
	React.useEffect(() => {
		navigate('/change-password', { replace: true });
	}, [navigate]);
	return <FuseLoading />;
}

function Authentication(props: AuthenticationProps) {
	const { children } = props;
	const location = useLocation();

	return (
		<FuseAuthProvider providers={authProviders}>
			{(authState) => {
				const userRole = authState?.user?.role as User['role'];
				const loginRedirectUrl = (authState?.user?.loginRedirectUrl as string) || '/';
				// Gate: if token says MustChangePassword, divert to change-password
				const accessToken = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
				const mustChange = accessToken ? mustChangePasswordFromToken(accessToken) : false;

				if (authState?.isAuthenticated && mustChange) {
					// Avoid redirect loop/blank screen when already on change-password
					if (location.pathname !== '/change-password') {
						return <RedirectToChangePassword />;
					}
				}

				return (
					<FuseAuthorization
						userRole={userRole}
						loginRedirectUrl={loginRedirectUrl}
					>
						{children}
					</FuseAuthorization>
				);
			}}
		</FuseAuthProvider>
	);
}

export default Authentication;
